var React = require('react');
var ReactNative = require('react-native');

import Icon from './wrappers/ReUpIcon';
var moment = require('moment');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ArcMeter = require('./ArcMeter.js')
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpButton = require('./ReUpButton');
var NetworkManager = require('./NetworkManager');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKButton,
} = MK;

function polarToCartesian(centerX, centerY, radius, angleInDegrees)
{
  var angleInRadians = angleInDegrees * Math.PI / 180.0;
  var x = centerX + radius * Math.cos(angleInRadians);
  var y = centerY + radius * Math.sin(angleInRadians);
  return [x,y];
}

function svgArc(startAngle, endAngle, percentage)
{
  while(startAngle < 0) startAngle += 360;
  while(endAngle < 0 || endAngle < startAngle) endAngle += 360;

  var portionAngle = ((endAngle - startAngle))*(percentage);
  var stopAngle = startAngle+portionAngle;

  var [sx,sy] = polarToCartesian(50, 50, 40, startAngle%360);
  var [ex,ey] = polarToCartesian(50, 50, 40, stopAngle);

  var flag = (stopAngle-startAngle)%360 < 180 ? "0" : "1";

  return "M "+ex+" "+ey+" A 40 50 0 "+flag+" 0 "+sx+" "+sy;
}

var Rewards = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      rewards : [],
      oneTimeRewards : [],
      angle : 10,
    }
  },

  componentDidMount : function()
  {
    this.didUpdate();
  },

  didUpdate : function(data)
  {
    var rewards = this;
    // if( this.props.appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
    // {
    //   rewards.setState({rewards:[
    //         {
    //             "RewardID": "-1",
    //             "RewardName": "Free Item",
    //             "Description": "Enjoy one of our signature Items, on the house!",
    //             "Points": "100",
    //             "IsDeleted": "0"
    //         },
    //         {
    //             "RewardID": "-2",
    //             "RewardName": "Free Thing",
    //             "Description": "Feeling thirsty today? We've got the Thing you need!",
    //             "Points": "200",
    //             "IsDeleted": "0"
    //         },
    //         {
    //             "RewardID": "-3",
    //             "RewardName": "Free Stuff",
    //             "Description": "Keep it up! You've got the Stuff!",
    //             "Points": "500",
    //             "IsDeleted": "0"
    //         }
    //     ]});
    //     return;
    // }
    this.props.appManager.getDataType("Rewards", function(data)
    {
      if( typeof data !== 'undefined' && data != null )
      {
        var deduplicatedRewards = [];
        for( var i = 0; i < data.length; i++ )
        {
          var alreadyExists = false;
          var reward = data[i];
          for( var j = 0; j < deduplicatedRewards.length; j++ )
          {
            if( reward.RewardID == deduplicatedRewards[j].RewardID )
            {
              if( typeof deduplicatedRewards[j].others === 'undefined' ) deduplicatedRewards[j].others = [];
              deduplicatedRewards[j].others.push(reward);
              alreadyExists = true;
            }
          }
          if( !alreadyExists )
          {
            deduplicatedRewards.push(reward);
          }
        }
        rewards.setState({rewards:deduplicatedRewards});     
      }
    })

    this.props.appManager.getDataType("OneTimeRewards", function(data)
    {
      if( typeof data !== 'undefined' && data != null )
      {
        var deduplicatedOneTimeRewards = [];
        for( var i = 0; i < data.length; i++ )
        {
          var alreadyExists = false;
          var reward = data[i];
          for( var j = 0; j < deduplicatedOneTimeRewards.length; j++ )
          {
            if( reward.RewardID == deduplicatedOneTimeRewards[j].RewardID )
            {
              if( typeof deduplicatedOneTimeRewards[j].others === 'undefined' ) deduplicatedOneTimeRewards[j].others = [];
              deduplicatedOneTimeRewards[j].others.push(reward);
              alreadyExists = true;
            }
          }
          if( !alreadyExists )
          {
            deduplicatedOneTimeRewards.push(reward);
          }
        }
        rewards.setState({oneTimeRewards:deduplicatedOneTimeRewards});        
      }
    })
  },

  didSelectReward : function(reward)
  {
    if( reward.RewardType == 0 || reward.RewardType == 1 ) // points for product or one-time reward
    {
      this.props.appActions.requestFeatureName("UseReward",{reward:reward});
    }
    else if( reward.RewardType == 2 )
    {
      var thisThing = this;
      var appManager = this.props.appManager;
      var appActions = this.props.appActions;
      var locManager = appManager.getLocalizationManager();
      var title = locManager.localizedStringForKey("REDEEM_REWARD_ALERT_TITLE", "Redeem Reward");
      var body = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_BODY", [locManager.localizedPoints(reward.Points), locManager.localizedDollarsShort(reward.Credit)], "Are you sure you want to redeem %0% to add %1% to your account?");
      var buttonTitle = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_BUTTON", [locManager.localizedPts(reward.Points)], "Use %0%");
      appActions.showLocalizedAlert(title, body, ["NO_ALERT_BUTTON", buttonTitle], [function()
      {
        appActions.hideAlert();
      }, function()
      {
        appActions.setSpinnerShown(true);
        NetworkManager.clientRedeemReward(appManager, reward.RewardID, ()=>
        {
          if( typeof thisThing.refs.ptr !== 'undefined' ) thisThing.refs.ptr.doOnlineUpdate();
          setTimeout(()=>appActions.setSpinnerShown(false), 500);
        }, ()=>
        {
          appActions.setSpinnerShown(false);
          appActions.showNetworkErrorAlert(function(){}, function(){})
        }, ()=>
        {
          appActions.setSpinnerShown(false);
          appActions.showNetworkErrorAlert(function(){}, function(){})
        })
        appActions.hideAlert();
      }], function(){})
    }
  },

  getLocalizedRewardData: function(reward)
  {
    var preferredLocale = this.props.appManager.getActiveLocale();
    var localizedRewardData = {};
    if( typeof reward.LocaleOverride !== 'undefined' && reward.LocaleOverride != null && reward.LocaleOverride.length > 0  )
    {
      var preferredLocaleOverrides = JSON.parse(reward.LocaleOverride);
      if( typeof preferredLocaleOverrides[preferredLocale] !== 'undefined' )
      {
        localizedRewardData.name = preferredLocaleOverrides[preferredLocale].RewardName;
        localizedRewardData.description = preferredLocaleOverrides[preferredLocale].Description;
      }
      else
      {
        localizedRewardData.name = reward.RewardName;
        localizedRewardData.description = reward.Description;
      }
    }
    else
    {
        localizedRewardData.name = reward.RewardName;
        localizedRewardData.description = reward.Description;
    }
    
    return localizedRewardData;
  },

  render: function()
  {
    var thisRewards = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    var buttonPrimaryTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");

    var rewards = this.state.rewards.sort(function(a,b)
    {
      if( a.Points == b.Points ) return b.RewardName.localeCompare(a.RewardName);
      else return a.Points - b.Points;
    });

    var disableScan = this.props.featureData.disableScan === true;
    var additionalRewardProps = {};
    if( !disableScan && (typeof this.props.extras === 'undefined' || !this.props.extras.disableUseReward) )
    {
      additionalRewardProps = {
        icon:'angle-right',
        iconColor:'red'
      }
    }

    var oneTimeRewards = this.state.oneTimeRewards.sort(function(a,b)
    {
      if( a.DateExpires == b.DateExpires ) return b.RewardName != null ? b.RewardName.localeCompare(a.RewardName) : 0;
      else 
      {
        var dateA = new Date(a.DateExpires.replace(' ', 'T')+'Z')
        var dateSecondsA = moment(dateA).valueOf();
        var dateB = new Date(b.DateExpires.replace(' ', 'T')+'Z')
        var dateSecondsB = moment(dateB).valueOf();

        return dateSecondsA - dateSecondsB;
      }
    });

    var numUserPoints = user[ModelConstants.Points];

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />
        <ReUpScrollView ref="ptr" bounces={true} responder={this} featureName="Rewards" isEmpty={rewards.length <= 0}>
          {
            oneTimeRewards.length > 0 ?
              <View style={[styles.instructionContainer, {backgroundColor: instructionColor, color:instructionTitleColor}]}>
                <View style={{alignSelf:'center'}}>
                  <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                    {locManager.localizedStringForKey("ONE_TIME_REWARD_STATMENT", "You have limited time rewards.")}
                  </ReUpText>
                </View>
                <View style={{flex:1}} />
                <ReUpIconButton type={3}
                  appManager={appManager}
                  featureData={this.props.featureData}
                  appActions={this.props.appActions}
                  onPress={()=>
                    {
                      thisRewards.props.appActions.showAlert(
                        locManager.localizedStringForKey("ONE_TIME_REWARD_ALERT_TITLE", "Your Limited Time Rewards"),
                        locManager.localizedStringForKey("ONE_TIME_REWARD_ALERT_BODY", "Limited time rewards disappear after their expiry date if not used."),
                        [locManager.localizedStringForKey("GOT_IT_ALERT_BUTTON")],[thisRewards.props.appActions.hideAlert], function(){})
                    }}
                  />
              </View>
            : null
          }
          {
            oneTimeRewards.length > 0 ?
              <ShadowView appManager={appManager} layout={this.state.layout} />
            : null
          }
          {
            oneTimeRewards.length > 0 ?
              oneTimeRewards.map(function(reward, index)
              {
                var localizedRewardData = thisRewards.getLocalizedRewardData(reward);
                if( typeof reward.others !== 'undefined' && reward.others.length > 0 ) name += " (" + (1 + reward.others.length) + ")";
                
                var iconName = reward["IsBirthday"] ? "birthday-cake" : "star";
                var other = {};
                if( !disableScan )
                {
                  other.icon = 'angle-right';
                  other.onPress = ()=>{thisRewards.didSelectReward(reward);};
                }
                return (
                    <View style={{overflow:'auto'}}>
                  <ReUpButton key={reward.RewardID} appManager={appManager} isTertiary={true}
                    iconColor={'red'}
                    maskBorderRadius={0}
                    style={{backgroundColor: 'transparent', padding: 0, alignSelf:'stretch', margin:0, width:-1, height:-1}}
                    {...other}
                  >
                  <View style={{flex:1}}>
                    <View style={{flexDirection:'row', alignItems:'center'}}>
                      <View style={{margin:20, width:80, height:80, borderRadius:40, alignItems:'center', backgroundColor:buttonPrimaryColor, justifyContent:'center'}}>
                        <View style={{marginTop:5}}>
                          <Icon name={iconName} size={44} color={buttonPrimaryTitleColor}/>
                        </View>
                      </View>
                      <View style={{marginRight:20, flex:1, flexDirection:'column'}}>
                        <View>
                          <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor}]}>
                            {localizedRewardData.name}
                          </ReUpText>
                        </View>
                        <View style={{height:4}} />
                        <View>
                          <ReUpText appManager={appManager} style={{color:generalTitleColor}}>
                            {localizedRewardData.description}
                          </ReUpText>
                        </View>
                      </View>
                    </View>
                  </View>
                  <View style={{
                    height:1,
                    position:'absolute',
                    left:0, right:0, bottom:0,
                    backgroundColor:'#DADADA'
                  }}/>
                  </ReUpButton>
                    </View>)
              })
            : null
          }
          <View style={[styles.instructionContainer, {backgroundColor: instructionColor, color:instructionTitleColor}]}>
            <View style={{alignSelf:'center'}}>
              <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                {pointsLeftStatement}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <ReUpIconButton type={3}
              appManager={appManager}
              featureData={this.props.featureData}
              appActions={this.props.appActions}
              />
          </View>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          {
            rewards.map(function(reward, index)
            {
              var afforded = parseInt(numUserPoints) >= parseInt(reward.Points);
              if( reward.IsDeleted == "1" ) return <View key={reward.RewardID} />
              var fraction = Math.min(1,parseFloat(reward.Points) <= 0 ? 1 : parseFloat(numUserPoints)/parseFloat(reward.Points));
              var amountFontSize = 30 - ((reward.Points + "").length > 3 ? ((reward.Points + "").length - 3)*5 : 0);
              var localizedRewardData = thisRewards.getLocalizedRewardData(reward);

              return (
                  <View style={{overflow:'auto'}}>
                    <ReUpButton key={reward.RewardID} appManager={appManager} isTertiary={true}
                  maskBorderRadius={0}
                  enabled={afforded}
                  style={{backgroundColor: 'transparent', padding: 0, alignSelf:'stretch', margin:0, width:-1, height:-1}}
                  onPress={()=>{if( !disableScan && (typeof thisRewards.props.extras === 'undefined' || !thisRewards.props.extras.disableUseReward) ) thisRewards.didSelectReward(reward);}}
                  {...additionalRewardProps}
                >
                <View style={{flex:1}}>
                  <View style={{flexDirection:'row', alignItems:'center'}}>
                    <View style={{margin:5, width:110, height:110, alignItems:'center', justifyContent:'center'}}>
                      <ArcMeter fgColor={profileMeterColor} bgColor={profileMeterBackgroundColor} percentage={fraction} style={{width:100,height:100}}>
                        <View>
                          <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.rewardAmount,{fontSize:amountFontSize, color:generalTitleColor}]}>
                            {reward.Points}
                          </ReUpText>
                        </View>
                      </ArcMeter>
                    </View>
                    <View style={{marginRight:20, flex:1, flexDirection:'column'}}>
                      <View>
                        <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor}]}>
                          {localizedRewardData.name}
                        </ReUpText>
                      </View>
                      <View style={{height:4}} />
                      <View>
                        <ReUpText appManager={appManager} style={{color:generalTitleColor}}>
                          {localizedRewardData.description}
                        </ReUpText>
                      </View>
                    </View>
                  </View>
                </View>
                <View style={{
                  height:1,
                  position:'absolute',
                  left:0, right:0, bottom:0,
                  backgroundColor:'#DADADA'
                }}/>
                </ReUpButton>
                  </View>)
            })
          }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  rewardRowContainer: {

  },
  rewardRow: {
    flexDirection:'row',
    alignItems:'center',
  },
  rewardDivider: {
    height:1,
    backgroundColor:'#DADADA'
  },
  rewardLeftContainer: {
    width:100,
    height:100,
    paddingTop:8,
    marginLeft:4,
    marginRight:4,
    paddingBottom:8,
    justifyContent:'center',
    alignItems:'center',
  },
  rewardAmountContainer: {
    width:80,
    height:80,
    borderRadius:40,
    borderWidth:8,
    margin:10,
    justifyContent:'center',
    alignItems:'center',
    alignSelf:'center',
    flex:1,
  },
  rewardAmount: {
    fontSize:34,
    alignSelf:'center',
    justifyContent:'center',
  },
  rewardRightContainer: {
    flex:1,
    justifyContent:'center',
    paddingRight:8,
    paddingBottom:4,
    paddingTop:4
  },
  rewardDescription: {
    padding:0,
    margin:0,
    opacity:.8,
  }

});

Rewards.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn ) return [];
  else
  {
    var user = appManager.currentUser();
    var points = parseFloat(user[ModelConstants.Points]);
    var rewards = typeof data.Rewards !== 'undefined' ? data.Rewards : [];
    var rewards = typeof data.Rewards !== 'undefined' ? data.Rewards.sort(function(a,b)
    {
      return a.Points - b.Points;
    }) : [];
    if( typeof rewards === 'undefined' || rewards == null || rewards.length <= 0 ) return [];

    var affordedReward = null;
    for( var i = 0; i < rewards.length; i++ )
    {
      var reward = rewards[i];
      if( reward.Points <= points )
      {
        affordedReward = reward;
      }
      else
      {
        break;
      }
    }
    if( affordedReward == null ) return [];

    // get date acheived
    var sortOrder = -1;
    if( typeof data.Transactions !== 'undefined' )
    {
      var trans = data.Transactions;
      var runningPoints = points;
      var rewardTrans = null;
      for( var i = 0; i < trans.length; i++ )
      {
        var thisTrans = trans[i];
        runningPoints -= thisTrans.Points;
        if( runningPoints < affordedReward.Points ) break;
        rewardTrans = thisTrans;
      }
      if( rewardTrans != null )
      {
        var time = appManager.getTime(rewardTrans.Timestamp);
        sortOrder = (new Date()).getTime() - time;
      }
    }

    sortOrder -= 1000; // reduce by a second so that it is above transaction history
    var cheapestReward = rewards[0]
    if( points < cheapestReward.Points) return [];

    var didSelect = function() {appActions.requestFeatureName("Rewards")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : sortOrder
    }];
  }
}

Rewards.dataDependencies = ["Users", "Rewards", "OneTimeRewards", "Transactions"];

module.exports = Rewards;



// WEBPACK FOOTER //
// ./src/Rewards.js